import React          from 'react';
import { Observe }    from 'rewire-core';
import { ICell }      from 'rewire-grid';
import { withStyles } from 'rewire-ui';
import { Theme }      from '@material-ui/core/styles';
import Typography     from '@material-ui/core/Typography';

const styles = (_theme: Theme) => ({
  link: {
    width: '100%',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  type: {
    fontSize: '1.1em',
    fontWeight: 'bold',
    color: '#0060bf',
    cursor: 'pointer',
  },
});

interface IActionCellProps {
  classes: Record<string, string>;
  cell: ICell;
}

const ActionCell: React.FunctionComponent<{cell: ICell}> = React.memo(withStyles<IActionCellProps, any>(styles, (props) => {
  const {cell, classes} = props;
  const click           = cell.column.typeOptions && cell.column.typeOptions.click;
  const linkClass       = click ? classes.link : '';

  return <Observe>{() => {
    let value = cell.value;
    if (cell.column.map) {
      value = cell.column.map(value);
    }

    return <a className={linkClass} onClick={() => click && click(cell)} ><Typography variant='body2' className={classes.type}>{value}</Typography></a>;
  }}</Observe>;

}));

export default ActionCell;
